<!--
  After the scene's name: the scene row has no room for a column of its own (§8.2). An amber or red
  status is an icon, its words on hover (the tooltip starts with them); the others are one short
  chip, the tooltip carrying the rest. `tabindex` earns either its tooltip on keyboard focus; the
  aria-label says the same to a screen reader, and aria-hidden="false" keeps mat-icon from hiding it.
-->
<ng-container *ngIf="label">
  <mat-icon
    *ngIf="icon; else chip"
    class="stac-scene-icon material-icons-outlined"
    [ngClass]="'tone-' + label.tone"
    tabindex="0"
    aria-hidden="false"
    [attr.aria-label]="label.tooltip"
    [matTooltip]="label.tooltip"
    matTooltipPosition="above"
    matTooltipClass="stac-scene-status-tooltip"
  >{{ icon }}</mat-icon>
  <ng-template #chip>
    <span
      class="stac-scene-status"
      [ngClass]="'tone-' + label.tone"
      tabindex="0"
      [attr.aria-label]="label.tooltip ? label.text + '. ' + label.tooltip : label.text"
      [matTooltip]="label.tooltip"
      matTooltipPosition="above"
      matTooltipClass="stac-scene-status-tooltip"
    >{{ label.text }}</span>
  </ng-template>
</ng-container>
